import axios from 'axios'
import api from './http'
import { generateHeaders, generateHeadersByKeyAndSecret } from './sign'

const TRACKING_METHOD = 'api.burton.tracking.report.2812'
const TRACKING_ROUTE = '/dw/admin/api/tracking/route/rest'
const DEFAULT_APP_KEY = 'weinxqlhhktop'
const burtonClient = axios.create({
  timeout: 120000
})

function toSafeJson(value) {
  if (!value) return null
  if (typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

function getAuthUser() {
  return toSafeJson(localStorage.getItem('auth-user')) || {}
}

async function buildTrackingHeaders() {
  const authUser = getAuthUser()
  const appKey =
    authUser.appKey ||
    authUser.loginName ||
    authUser.login_name ||
    DEFAULT_APP_KEY
  const appSecret = authUser.appSecret

  if (appKey && appSecret) {
    return generateHeadersByKeyAndSecret(appKey, appSecret)
  }

  return generateHeaders(DEFAULT_APP_KEY)
}

export async function fetchBurtonTracking(requestBody) {
  const headers = await buildTrackingHeaders()
  const response = await api.post(
    TRACKING_ROUTE,
    {
      method: TRACKING_METHOD,
      requestBody
    },
    headers
  )
  if (!response || response.code !== 200 || !response.success) {
    throw new Error(response?.errorMsg || '查询Burton访问数据失败')
  }
  return Array.isArray(response.data) ? response.data : []
}

export async function getBurtonStoreConfig() {
  const response = await api.get('/auth/api/v1/dict/code/burton_config')
  if (!response || response.code !== 200) {
    throw new Error(response?.errorMsg || '获取Burton配置失败')
  }

  const dictData = response?.data || {}
  const dictValue = dictData?.value
  const config = toSafeJson(dictValue) || dictData || {}
  if (!config.url || !config.account || !config.pwd) {
    throw new Error('Burton配置缺少url/account/pwd')
  }
  return config
}

export async function loginBurtonStore(config) {
  const response = await burtonClient.post(
    `${config.url}/api/v2/auth/login`,
    {
      username: config.account,
      password: config.pwd
    },
  )

  const token = response?.data?.data?.token
  if (!token) {
    throw new Error(response?.data?.errorMsg || 'Burton服务登录失败')
  }
  return token
}

export async function execBurtonOrderSql(config, token, sql, pageQuery) {
  const requestBody = { sql }
  if (pageQuery && typeof pageQuery === 'object') {
    requestBody.pageQuery = pageQuery
  }
  const response = await burtonClient.post(
    `${config.url}/api/v2.2/dbTools/mysql/execCommand`,
    requestBody,
    {
      headers: {
        token,
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    }
  )

  if (!response?.data?.success) {
    throw new Error(response?.data?.errorMsg || '执行Burton订单SQL失败')
  }

  return response?.data?.data || {}
}
